import { DashboardPreset, describeRange, isRangeReady } from '../dateFilters';
import * as S from '../styles';

const PRESETS: { key: Exclude<DashboardPreset, 'custom'>; label: string }[] = [
  { key: '7d', label: '7 dias' },
  { key: 'mes', label: 'Este mês' },
  { key: 'ano', label: 'Este ano' },
];

interface DateFilterBarProps {
  startDate: string;
  endDate: string;
  preset: DashboardPreset;
  isFetching: boolean;
  onChangeStartDate: (value: string) => void;
  onChangeEndDate: (value: string) => void;
  onSelectPreset: (preset: Exclude<DashboardPreset, 'custom'>) => void;
}

export function DateFilterBar({
  startDate,
  endDate,
  preset,
  isFetching,
  onChangeStartDate,
  onChangeEndDate,
  onSelectPreset,
}: DateFilterBarProps) {
  const rangeReady = isRangeReady(startDate, endDate);
  const invertido = !!startDate && !!endDate && startDate > endDate;

  return (
    <S.FilterBar>
      <div className="field">
        <label htmlFor="dashboard-start-date">Data inicial</label>
        <input
          id="dashboard-start-date"
          type="date"
          value={startDate}
          max={endDate || undefined}
          aria-invalid={invertido}
          onChange={(e) => onChangeStartDate(e.target.value)}
        />
      </div>

      <div className="field">
        <label htmlFor="dashboard-end-date">Data final</label>
        <input
          id="dashboard-end-date"
          type="date"
          value={endDate}
          min={startDate || undefined}
          aria-invalid={invertido}
          onChange={(e) => onChangeEndDate(e.target.value)}
        />
      </div>

      <div className="presets">
        {PRESETS.map(({ key, label }) => (
          <S.PresetButton
            key={key}
            type="button"
            active={preset === key}
            aria-pressed={preset === key}
            onClick={() => onSelectPreset(key)}
          >
            {label}
          </S.PresetButton>
        ))}
      </div>

      <div className="status">
        {invertido ? (
          <span className="error">
            A data inicial não pode ser maior que a data final.
          </span>
        ) : rangeReady ? (
          <>
            <span>Período aplicado: {describeRange({ startDate, endDate })}</span>
            {isFetching && <span className="loading">Atualizando…</span>}
          </>
        ) : (
          <span>Selecione a data inicial e a data final.</span>
        )}
      </div>
    </S.FilterBar>
  );
}
